var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "money-input",
      class: [
        _vm.className,
        {
          focused: _vm.focused,
          focusedOther: _vm.focusedOther,
          hasError: _vm.hasError,
          "non-empty": !!_vm.displayValue
        }
      ]
    },
    [
      _c("label", { staticClass: "label-txt" }, [
        _vm._v(_vm._s(_vm.placeholder))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "currency" }, [
        _vm._v(_vm._s(_vm.currencySymbol))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.displayValue,
            expression: "displayValue"
          }
        ],
        ref: "moneyValue",
        staticClass: "no-spinners",
        class: [_vm.statusToConfirmClass, { invisible: _vm.stakeChanged }],
        attrs: {
          type: "text",
          autocomplete: "off",
          inputmode: "decimal",
          step: "0.01",
          disabled: _vm.currentBetSlipState >= 1 || _vm.stakeChanged,
          id: _vm.inputType + "BetSlipId" + _vm.perType
        },
        domProps: { value: _vm.displayValue },
        on: {
          focus: function($event) {
            return _vm.setFocus(_vm.id)
          },
          change: function($event) {
            return _vm.change(_vm.id)
          },
          blur: function($event) {
            return _vm.killFocus(_vm.id)
          },
          keyup: function($event) {
            if (!$event.type.indexOf("key") && $event.keyCode !== 13) {
              return null
            }
            return _vm.invokeBlur()
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.displayValue = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _vm.inputType == "wager" && _vm.stakeChanged
        ? _c("div", { staticClass: "stakeChange" }, [
            _c("span", { staticClass: "stakeNew" }, [
              _vm._v(" " + _vm._s(_vm.stakeChange.new))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "stakeOld" }, [
              _vm._v(_vm._s(_vm.stakeChange.old) + " ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasError && !_vm.focusOn,
              expression: "hasError && !focusOn"
            }
          ],
          staticClass: "error-badge"
        },
        [_c("v-icon", [_vm._v("info")])],
        1
      ),
      _vm._v(" "),
      _c("span", { staticClass: "clear-btn" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.displayValue && _vm.focusOn,
                expression: "displayValue && focusOn"
              }
            ],
            on: {
              mousedown: function($event) {
                return _vm.clearValue()
              }
            }
          },
          [_c("v-icon", [_vm._v("close")])],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fa88d2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fa88d2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/common/moneyInput.vue
// module id = null
// module chunks = 